import React from "react";
import {
  LoyaltyHomeIcon,
  LoyaltyProfileIcon,
  LoyaltyCalendarIcon,
} from "views/loyalty-app/app-loyalty-views/icons";
import messages from "views/loyalty-app/app-loyalty-views/translations";
import { useIntl } from "react-intl";
import { ROUTES } from "views/loyalty-app/app-loyalty-views/LoyaltyRoutes";
import { GiftFilled, InfoCircleFilled } from "@ant-design/icons";

const BottomNavigationItem = ({
  icon,
  label,
  handleNavigation,
  path,
  active,
}) => {
  return (
    <div
      className="loyalty-bottom-navigation-item"
      onClick={() => handleNavigation(path)}
      style={{ cursor: "pointer" }}
    >
      <div
        className={`loyalty-bottom-navigation-item-icon ${
          active ? "active" : ""
        }`}
      >
        {icon}
      </div>
      <div
        className={`loyalty-bottom-navigation-item-label ${
          active ? "active" : ""
        }`}
      >
        {label}
      </div>
    </div>
  );
};

const BottomNavigation = ({ active, handleNavigation }) => {
  const { formatMessage } = useIntl();
  const bottomNavigationItems = [
    {
      icon: <LoyaltyHomeIcon />,
      label: formatMessage(messages.homeLabel),
      path: ROUTES.HOME,
    },
    {
      icon: <LoyaltyCalendarIcon />,
      label: formatMessage(messages.appointmentsLabel),
      path: ROUTES.APPOINTMENT_DETAILS,
    },
    {
      icon: <GiftFilled />,
      label: formatMessage(messages.recordsLabel),
      path: ROUTES.REWARDS,
    },
    {
      icon: <InfoCircleFilled />,
      label: formatMessage(messages.infoLabel),
      path: ROUTES.INFO,
    },
    {
      icon: <LoyaltyProfileIcon />,
      label: formatMessage(messages.profileLabel),
      path: ROUTES.PROFILE,
    },
  ];
  return (
    <div className="loyalty-bottom-navigation">
      {bottomNavigationItems.map((item) => (
        <BottomNavigationItem
          key={item.label}
          {...item}
          active={active === item.path}
          handleNavigation={handleNavigation}
        />
      ))}
    </div>
  );
};

export default BottomNavigation;
